import { useState, useEffect, useRef } from "react";
import { useOnClickOutside } from "../../customHooks/useOnClickOutside";

interface Props {
    onTextFilter: any;
    onCancelFilter: any;
}

const HeaderTextFilter = (props: Props) => {
    const [toggleFilter, setToggleFilter] = useState(false);
    const [filterBy, setFilterBy] = useState('');

    const handleSearchTextChange = (event: any) => {
        const value = event.target.value;
        setFilterBy(value);
    };

    const handleKeyDown = (event: any) => {
        const { keyCode } = event;
        if (keyCode === 13) {
            //props.onTextFilter(filterBy);
            setToggleFilter(false);
        }
        if (keyCode === 27) {
            setFilterBy('');
            setToggleFilter(false);
            //props.onCancelFilter();
        }
    };

    let inputRef;
    const ref = useRef(null);
    useEffect(() => {
        inputRef = ref.current;
        if (toggleFilter) {
            inputRef.focus();
        }
    }, [toggleFilter]);

    useEffect(() => {
        props.onTextFilter(filterBy);
    }, [filterBy]);

    useOnClickOutside(ref, (e: any) => {
        if (e.srcElement.className.indexOf('fa-bars') === -1) {
            setToggleFilter(false);
            //props.onTextFilter(filterBy);
        }
    });

    return (
        <>
            <div className="col-filter" onClick={(a: any) => {
                if (a.target.className.indexOf('fa-bars') > -1) {
                    setToggleFilter(!toggleFilter);
                    //inputRef.current?.focus();
                }
            }}>
                {filterBy && <i className="fas fa-filter" onClick={() => {
                    setFilterBy('');
                    setToggleFilter(false);
                    //props.onTextFilter('');
                }}></i>}
                <i className="fas fa-bars"></i>
                {(toggleFilter) &&
                    <div className="filter-wrapper">
                        <div className="filter-body">
                            <div>
                                <input ref={ref} className="col-filter-input" type="text" value={filterBy} onKeyDown={handleKeyDown} onChange={handleSearchTextChange}></input>
                            </div>
                        </div>
                    </div>}
            </div>
        </>
    );
}

export default HeaderTextFilter;